<template>
  <section id="equipos" class="grey lighten-4">
    <vertical-divider :class="'vertical'" />
    <v-container class="extra-padding pb-0" fluid>
      <v-row justify="center" mb="10">
        <v-col cols="10" md="12" class="mt-n8">
          <h1 class="text-h2 text-uppercase text-center primary--text">
            Equipos
          </h1>
          <v-divider class="pt-1 mx-auto my-2 secondary" width="50"></v-divider>
        </v-col>

        <v-col cols="12" md="10">
          <v-row justify="center">
            <v-col cols="12" md="4" v-for="e in equipamento" :key="e.i">
              <v-card max-width="400" class="mx-auto">
                <v-carousel
                  continuous
                  :cycle="true"
                  :reverse="true"
                  show-arrows
                  height="300"
                >
                  <v-carousel-item v-for="link in e.links" :key="link.i">
                    <v-img
                      :src="require('@/assets/equipamento/' + link)"
                      max-height="300"
                      height="300"
                      la
                    >
                    </v-img>
                  </v-carousel-item>
                </v-carousel>
                <v-card-text class="pt-0">
                  <v-list>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title
                          class="title primary--text text-uppercase"
                        >
                          {{ e.title }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mb-6"></v-divider>
                    <v-list-item v-for="item in e.items" :key="item.i">
                      <v-list-item-content class="my-0 py-0">
                        <p class="grey--text body-1">
                          <v-icon small color="primary">mdi-forward</v-icon>
                          {{ item }}
                        </p>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" class="mb-0 pb-0">
          <div class="text-center mt-10 mb-0 pb-0">
            <v-btn
              color="primary"
              x-large
              @click="$vuetify.goTo('#contact', 500, 0)"
              >Envianos tu consulta</v-btn
            >
          </div>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
  export default {
    name: "Equipos",
    components: {
      VerticalDivider: () => import("@/components/shape/VerticalDivider.vue"),
    },
    data: () => ({
      equipamento: {
        camiones: {
          title: "camiones",
          items: [
            "Volcadores 6x4 de 20mt3",
            "Volcadores 8x4 de 27mt3",
            "Regadores 4x2 de 10.000 litros",
            "Camión estación móvil",
          ],
          links: ["camiones/1.jpeg", "camiones/2.jpeg", "camiones/3.jpeg"],
        },
        equipos: {
          title: "equipos",
          items: [
            "Minicargadoras",
            "Excavadoras de orugas de 5 a 25Tn",
            "Excavadora Long reach Alcanza 16,5m",
            "Motoniveladoras de 150Hp",
            "Cargadora frontal de 3mt3",
            "Topadores de 200Hp",
            "Compactadores autopropulsados tambor pata de cabra / liso",
            "Tractor con rastra vial",
          ],
          links: ["equipos/1.jpeg", "equipos/2.jpeg", "equipos/3.jpeg"],
        },
        accesorios: {
          title: "accesorios",
          items: [
            "Martillos hidráulicos de 300 kg a 2500kg",
            "Camionetas d-c",
            "Camionetas c-s",
            "Tanques cisterna para combustible",
          ],
          links: [
            "accesorios/1.jpeg",
            "accesorios/2.jpeg",
            "accesorios/3.jpeg",
          ],
        },
      },

      colors: [
        "green",
        "secondary",
        "yellow darken-4",
        "red lighten-2",
        "orange darken-1",
      ],
      cycle: true,
      slides: ["First", "Second", "Third", "Fourth", "Fifth"],
    }),
  };
</script>

<style lang="sass" scoped>
  .title-card
      position: absolute
      bottom: 0
      left: 0
      right: 0
</style>
